/* eslint-disable */
import axios from 'axios'

// Módulo para obtener y modificar datos de usuario en trekksoft 
const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/'

const state = {
    activities: [], 
    last_called: null // workaround to avoid multiple requests to get_activities at the same subsecond
}

const actions = {
    async get_activities({
        commit
    }) {
        commit("ISLOADING", ["default", true], {
            root: true,
        });
        console.log('get_activities from activities.js')
        let now = (new Date()).getTime()
        let proceed = false
        if ( state.last_called != null && (now - state.last_called < 200) ) {
            proceed = false
        } else if ( state.last_called != null && (now - state.last_called >= 200)) {
            proceed = true
            state.last_called = (new Date()).getTime()
        } else {
            proceed = true
            state.last_called = (new Date()).getTime()
        }

        if ( proceed ) {
            return await axios
                .get(baseUrl + 'activities/activities_schedulers_summary/')
                .then(
                    response => {
                        commit('SET_ACTIVITIES', response.data)
                        commit("ISLOADING", ["default", false], {
                            root: true,
                        });
                    }
                )
        }
    },
    async get_activity_schedulers({
        commit
    }, payload) {
        commit("ISLOADING", ["default", true], {
            root: true,
        });
        return await axios
            .get(
                baseUrl + 'activities/activity_schedulers/' +
                '?activity_id=' + payload.activity_id
            )
            .then(response => {
                commit("ISLOADING", ["default", false], {
                    root: true,
                });
                return response.data
            })
    },
    async activity_set_group({
        commit
    }, payload) {
        return axios
            .patch(
                baseUrl + 'activities/' + payload.activity_id + '/activity_set_group/',
                payload.data
            )
    },
    async togglePickupService({
        commit, dispatch
    }, data) {
        commit("ISLOADING", ["booking", true], {
            root: true,
        });
        await axios
            .patch(
                baseUrl + 'activities/' + data.activity_id + '/toggle_pickup_service/'
            )
            .then(async response => {
                await dispatch('get_activities')
                commit("ISLOADING", ["booking", false], {
                    root: true,
                });
            })
    },
    async delete_activity_scheduler({
        commit, dispatch
    }, payload) {
        await axios
            .delete(
                baseUrl + 'activities/delete_activity_scheduler/?rule_id=' + payload.rule_id
            )
            .then(response => {
                return response.data
            })
    },
    async syncZTActivities({
        commit, dispatch
    }, data) {
        let url = process.env.VUE_APP_BASE_API + '/zt/sync_activities/'
        console.log(url)
        await axios
            .get(
                url
            ).then(async response => {
                await dispatch("get_activities")
            })
    }
}

const mutations = {
    SET_ACTIVITIES(state, activities) {
        state.activities = activities
    },
    RESET_ACTIVITIES(state) {
        state.activities = []
    }
}

export default {
    namespaced: true,
    state, 
    mutations,
    actions
}